// extracted by mini-css-extract-plugin
export var table = "_xl-0";